import { useApp } from './state/store';
import { useHistoryNavigation } from './hooks/useHistoryNavigation';
import { useTheme } from './hooks/useTheme';
import { useStatusBarColor } from './hooks/useStatusBarColor';
import { Screen1Start } from './screens/Screen1Start';
import { Screen2TimeWindow } from './screens/Screen2TimeWindow';
import { Screen3Results } from './screens/Screen3Results';
import { Screen4Detail } from './screens/Screen4Detail';
import { InstallPrompt } from './components/InstallPrompt';
import { AppLock } from './components/AppLock';

export function App() {
  const screen = useApp((s) => s.screen);
  useTheme();
  useHistoryNavigation();
  useStatusBarColor();

  return (
    <AppLock>
      <div className="phone-container">
        {screen === 1 && <Screen1Start />}
        {screen === 2 && <Screen2TimeWindow />}
        {screen === 3 && <Screen3Results />}
        {screen === 4 && <Screen4Detail />}
        <InstallPrompt />
      </div>
    </AppLock>
  );
}
